import React from 'react';
import './Footer.css';

interface FooterProps {
  currentPath?: string;
}

const Footer: React.FC<FooterProps> = ({ currentPath }) => {
  const currentYear = new Date().getFullYear();
  const isLoginPage = currentPath === '/';
  const isFixed = currentPath !== '/';

  return (
    <footer className={`site-footer ${isFixed ? 'site-footer--fixed' : ''} ${isLoginPage ? 'site-footer--minimal' : ''}`}>
      <div className="site-footer__inner">
        <p className="site-footer__copyright">
          <svg className="site-footer__copyright-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M14.83 14.83a4 4 0 1 1 0-5.66"/>
          </svg>
          <span className="site-footer__year">{currentYear}</span>
          <a 
            href="https://www.nexteksystems.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="site-footer__company"
          >
            Nextek Systems
          </a>
        </p>
        
        <span className="site-footer__dot" />
        
        <p className="site-footer__tagline">
          All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
